//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import styled from 'styled-components';

export const UIAContainer = styled.div.attrs({
  className: 'unison-component',
})`
  position: absolute;
  inset: 0;
`;
